import {
  CurrencyAmountForm,
  Loader,
  ServiceFeeDisplay,
} from '@/shared/components';
import { type DepositSbpFormProps } from '../model';
import { useCurrencyAmountFormConfig } from '@/shared/lib/formConfigFactory';

export function DepositSbpForm({
  form,
  handleFormSubmit,
  currencyOptions,
  minAmount,
  amountPlaceholder,
  commissionData,
  shouldShowCommission,
  formError,
  onCancel,
  className,
  isLoading,
}: DepositSbpFormProps) {
  const formConfig = useCurrencyAmountFormConfig({
    currencyOptions,
    minAmount,
    currencyLabelKey: 'common.currencyPlaceholder',
    amountLabelKey: 'common.amount',
    amountPlaceholderKey: amountPlaceholder,
    cancelButtonKey: 'common.cancel',
    showCancelButton: !!onCancel,
    customContentAfterFields:
      shouldShowCommission && commissionData ? (
        <ServiceFeeDisplay
          commissionData={commissionData}
          className="mt-[-1.2rem]"
        />
      ) : undefined,
    className,
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-[4rem]">
        <Loader />
      </div>
    );
  }

  return (
    <CurrencyAmountForm
      config={formConfig}
      form={form}
      onSubmit={handleFormSubmit}
      error={formError}
    />
  );
}
